import type {
  EvalCaseListItem,
  EvalTestCase,
  EvalTestCasesQueryParams,
} from './types'

export function getEvalTestCasesQueryParams(
  dutyId?: string
): EvalTestCasesQueryParams {
  const params: EvalTestCasesQueryParams = {
    limit: 100,
    sort_by: 'created_at',
    sort_order: 'desc',
  }

  if (dutyId) {
    params.duty_id = dutyId
  }

  return params
}

export function mapEvalTestCaseToListItem(
  testCase: EvalTestCase
): EvalCaseListItem {
  return {
    id: testCase.id,
    name: testCase.name || 'Untitled test case',
    channel: testCase.channel,
  }
}
